export class ElementsHandleAPI {

    constructor(obj, value, type, i) {
        this.obj = obj;
        this.value = value;
        this.type = type;
        this.i = i;
    }

    updateObj() {
        switch (this.type) {
            case "name": this.obj.name = this.value; break;
            case "firstname": this.obj.firstname = this.value; break;
            case "lastname": this.obj.lastname = this.value; break;
            case "email" : this.obj.email = this.value; break;
            case "phone":
                if (/^[0-9]*\+?[0-9]*$/gm.test(this.value)) {
                    this.obj.phone = this.value;
                }
                break;
            case "dni":
                if (/^[0-9]*\+?[0-9-A-Za-z\s\-]*$/.test(this.value)) {
                    this.obj.dni = this.value;
                }
                break;
            case "cif_nif":
                if (/^[0-9]*\+?[0-9-A-Za-z\s\-]*$/.test(this.value)) {
                    this.obj.cif_nif = this.value;
                }
                break;
            case "company": this.obj.company = this.value; break;
            case "address": this.obj.address = this.value; break;
            case "floor": this.obj.floor = this.value; break;
            case "door": this.obj.door = this.value; break;
            case "city": this.obj.city = this.value; break;
            case "postal_code":
                if (/^\d+$/.test(this.value)) {
                    this.obj.postal_code = this.value;
                }
                break;
            // USERS
            case "username" : this.obj.username = this.value; break;
            case "password" : this.obj.password = this.value; break;
            case "first_name" : this.obj.first_name = this.value; break;
            case "last_name" : this.obj.last_name = this.value; break;
            case "projects": this.obj.projects[this.i] = this.value; break;
            case "roles": this.obj.roles[0] = this.value; break;
            case "active": this.obj.active = !this.obj.active; break;
        }

        return this.obj;
    }
}